var _excluded = ["gutterSpace", "alignCenter", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var gutterBasicStyles = function gutterBasicStyles(gutterSpace) {
  var gutterSpaceX;
  var gutterSpaceY;
  if (gutterSpace.x) {
    gutterSpaceX = gutterSpace.x;
    gutterSpaceY = gutterSpace.y;
  } else {
    gutterSpaceX = gutterSpace;
    gutterSpaceY = gutterSpace;
  }
  return css(["margin-top:", ";margin-left:", ";> *{margin-top:", " !important;margin-left:", " !important;}"], space(-1 * gutterSpaceY), space(-1 * gutterSpaceX), space(gutterSpaceY), space(gutterSpaceX));
};
var gutterStyles = function gutterStyles(gutterSpace) {
  if (gutterSpace.small) {
    return css(["", ";", "{", ";}", "{", ";}"], gutterBasicStyles(gutterSpace.small), breakpoint("medium"), gutterBasicStyles(gutterSpace.medium), breakpoint("large"), gutterBasicStyles(gutterSpace.large));
  }
  return css(["", ";"], gutterBasicStyles(gutterSpace));
};
var alignCenterStyles = function alignCenterStyles(alignCenter) {
  if (alignCenter === "horizontal") {
    return css(["justify-content:center;"]);
  }
  if (alignCenter === "vertical") {
    return css(["align-items:center;"]);
  }
  return css(["align-items:center;justify-content:center;"]);
};
var StyledWrapOrg = styled.div.withConfig({
  componentId: "sc-2o2vz6-0"
})(function (_ref) {
  var $gutterSpace = _ref.$gutterSpace,
    $alignCenter = _ref.$alignCenter;
  return css(["", ";", ";display:flex;flex-wrap:wrap;"], gutterStyles($gutterSpace), $alignCenter && alignCenterStyles($alignCenter));
});
function WrapOrg(_ref2) {
  var gutterSpace = _ref2.gutterSpace,
    alignCenter = _ref2.alignCenter,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledWrapOrg, _extends({
    $gutterSpace: gutterSpace,
    $alignCenter: alignCenter
  }, restProps), children);
}
export default WrapOrg;